/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The application features:
 *   * SITE_OPERATION
 *   * SITE_MANAGEMENT
 *   * SUBSCRIPTION
 *   * TRANSACTION
 *   * AUTH_SUPPORT
 *   * VEHICLE
 *   * TICKET
 *   * USER
 *   * OCCUPANCY
 *   * PRICE
 *   * DASHBOARD
 *   * CONTACT
 *   * REPORTING
 *   * DAF
 */
export enum ApplicationFeature {
  SITE_OPERATION = 'SITE_OPERATION',
  SITE_MANAGEMENT = 'SITE_MANAGEMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TRANSACTION = 'TRANSACTION',
  AUTH_SUPPORT = 'AUTH_SUPPORT',
  VEHICLE = 'VEHICLE',
  TICKET = 'TICKET',
  USER = 'USER',
  OCCUPANCY = 'OCCUPANCY',
  PRICE = 'PRICE',
  DASHBOARD = 'DASHBOARD',
  CONTACT = 'CONTACT',
  REPORTING = 'REPORTING',
  DAF = 'DAF'
}
